import { computed, ref } from 'vue'

import type { ComputedRef, WritableComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

interface FilterOngoingOptions {
  initial: string | null
}

interface FilterOngoingReturn {
  options: AppSelectOption[]
  model: WritableComputedRef<string | undefined>
  query: ComputedRef<string | null>
}

const ongoingToIsNew: Record<string, string> = {
  yes: '0',
  no: '1',
}

const isNewToOngoing: Record<string, string> = {
  '0': 'yes',
  '1': 'no',
}

export const useFilterOngoing = ({ initial }: FilterOngoingOptions): FilterOngoingReturn => {
  const isNew = ref<string | null>(initial === '0' || initial === '1' ? initial : null)

  const options: AppSelectOption[] = [
    { value: 'yes', text: 'Yes' },
    { value: 'no', text: 'No' },
  ]

  const model = computed<string | undefined>({
    get: () => (isNew.value === null ? undefined : isNewToOngoing[isNew.value]),
    set: (value) => { isNew.value = value === undefined ? null : ongoingToIsNew[value] ?? null },
  })

  const query = computed<string | null>(() => isNew.value)

  return {
    options,
    model,
    query,
  }
}
